const menuRouter = [
    /**
     * 系统管理
     **/
    {
        path: '/menumanage',
        meta: { title: '菜单管理' },
        component: () => import('@/views/system/menumanage'),
        used: true,
    },
    {
        path: '/rolemanage',
        meta: { title: '角色管理' },
        component: () => import('@/views/system/rolemanage'),
        used: true,
    },
    {
        path: '/usermanage',
        meta: { title: '用户管理' },
        component: () => import('@/views/system/usermanage'),
        used: true,
    },
    {
        path: '/account',
        meta: { title: '账套设置' },
        component: () => import('@/views/system/account'),
        used: true,
    },
    {
        path: '/setmanage/optionset',
        meta: { title: '选项设置' },
        component: () => import('@/views/system/setmanage/optionSet'),
        used: true,
    },
    {
        path: '/setmanage/dictionary',
        meta: { title: '数据字典' },
        component: () => import('@/views/system/setmanage/dictionary'),
        used: true,
    },
    {
        path: '/usermessage',
        meta: { title: '站内信' },
        component: () => import('@/views/system/usermessage'),
        used: true,
    },
]

export default menuRouter
